let leftPattern = [
    { top: 2300, rotateX: 0, rotateY: 0, margin: -100 },
    { top: 50, rotateX: 0, rotateY: 0, margin: -190 },
    { top: 2300, rotateX: 180, rotateY: 0, margin: -110 },
    { top: 1500, rotateX: 0, rotateY: 0, margin: -120 }
];

let rightPattern = [
    { top: 900, rotateX: 0, rotateY: 0, margin: -130 },
    { top: 1000, rotateX: 0, rotateY: 0, margin: -190 },
    { top: 125, rotateX: 180, rotateY: 180, margin: -110 },
    { top: 1500, rotateX: 180, rotateY: 180, margin: -110 },
    { top: -50, rotateX: 0, rotateY: 0, margin: -50 }
];

function displayCircuitLines() {
    let pageHeight = document.querySelector(".page--circuitLines").offsetHeight;
    let vectorContainer = document.querySelector(".circuitLines");

    let topOffset = 0;
    let lineVector = document.querySelector(".circuitLine");
    while (topOffset < pageHeight) {
        leftPattern.map(pattern => {
            let clonedVector = lineVector.cloneNode(true);
            topOffset += pattern.top;
            if (topOffset < pageHeight) {
                clonedVector.style.transform = `rotateX(${pattern.rotateX}deg) rotateY(${pattern.rotateY}deg)`;
                clonedVector.style.top = `${topOffset}px`;
                clonedVector.style.marginRight = `${pattern.margin}px`;
                vectorContainer.appendChild(clonedVector);
            }
        });
    }
    topOffset = 0;
    while (topOffset < pageHeight) {
        rightPattern.map(pattern => {
            let clonedVector = lineVector.cloneNode(true);
            topOffset += pattern.top;
            if (topOffset < pageHeight) {
                clonedVector.style.transform = `rotateX(${pattern.rotateX}deg) rotateY(${pattern.rotateY}deg)`;
                clonedVector.style.top = `${topOffset}px`;
                clonedVector.style.left = 0;
                clonedVector.style.marginLeft = `${pattern.margin}px`;
                vectorContainer.appendChild(clonedVector);
            }
        });
    }
}

function init() {
    displayCircuitLines();
}

export default { init };
